import { DiagramNode } from "@/app/features/diagrams/components/shared/DiagramNode";

// Owns the fan-in, rank fusion, and output half of the retrieval diagram.
export function HybridSearchRetrievalResults() {
  return (
    <>
      <path
        d="M 190 292 L 190 316 L 350 316"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        opacity="0.5"
      />
      <path
        d="M 510 292 L 510 316 L 350 316"
        fill="none"
        stroke="#3b82f6"
        strokeWidth="1.6"
        strokeDasharray="5 4"
        opacity="0.85"
      />
      <circle cx="350" cy="316" r="3.5" fill="var(--ga-brass, #9c6b3e)" />
      <text
        x="350"
        y="307"
        textAnchor="middle"
        fill="var(--ga-brass, #9c6b3e)"
        className="text-[11px] font-mono font-bold"
      >
        candidate ranks
      </text>
      <path
        d="M 350 316 L 350 348"
        fill="none"
        stroke="var(--ga-brass, #9c6b3e)"
        strokeWidth="1.8"
        markerEnd="url(#hs-arrow-neutral)"
      />
      <DiagramNode
        x={200}
        y={350}
        width={300}
        height={48}
        label="Reciprocal Rank Fusion (RRF)"
        sublabel="Rank Aggregation & Rescoring"
        variant="standard"
      />
      <path
        d="M 350 398 L 350 436"
        fill="none"
        stroke="#10b981"
        strokeWidth="1.8"
        markerEnd="url(#hs-arrow-green)"
      />
      <DiagramNode
        x={210}
        y={438}
        width={280}
        height={48}
        label="Ranked Relevant Results"
        sublabel="High-Precision Candidate Output"
        variant="success"
      />
    </>
  );
}
